import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { DragDropContext as _dragDropContext, DropTarget as dropTarget } from 'react-dnd'
import { omit } from 'ramda'
import HTML5Backend, { NativeTypes } from 'react-dnd-html5-backend'
import TouchBackend from 'react-dnd-touch-backend'

const isTouchDevice = () => {
  if (typeof window !== 'undefined') {
    return 'ontouchstart' in document.documentElement
  }
  return false
}

const dragDropContext = _dragDropContext(isTouchDevice() ? TouchBackend : HTML5Backend)

export const DragDropContext = dragDropContext(({ children }) => (
  <React.Fragment>{children}</React.Fragment>
))

const boxTarget = {
  drop(props, monitor) {
    if (props.onChange) {
      props.onChange(monitor.getItem().files)
    }
  },
}

const makeDropTarget = dropTarget([NativeTypes.FILE], boxTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))

const DropAreaWrapper = styled.div`
  border-width: 2px;
  border-style: dashed;
  border-color: ${({ isOver, theme }) => (isOver ? theme.colors.stTropaz : theme.colors.alto)};
  transition: 150ms;
`

const dropArea = ({ children, connectDropTarget, ...props }) => (
  <DropAreaWrapper ref={connectDropTarget} {...omit(['onChange'], props)}>
    {children}
  </DropAreaWrapper>
)

dropArea.propTypes = {
  children: PropTypes.node.isRequired,
  connectDropTarget: PropTypes.func,
}

dropArea.defaultProps = {
  connectDropTarget: null,
}

export const DropArea = makeDropTarget(dropArea)
